export default {
  clientAndPartners: {
    metatag: {
      title: 'SIS Innov & Tech - Clientes y Aliados',
      description: 'Conozca a los clientes y aliados de SIS Innov & Tech',
    },
  },
}
